import * as Yup from 'yup'

import { i18n } from '../i18next'

// Country Code + Phone Number +5511999987777

export default Yup.string()
  .min(13, i18n.t('signUp.form.phoneNumber.error'))
  .max(14, i18n.t('signUp.form.phoneNumber.error'))
